<template>
  <div class="policy-content">
    <div class="card">
      <div class="sub-title">
        <div class="sub-title-bar"></div>
        <div class="sub-title-text">理赔概况</div>
        <div class="sub-title-date">{{ basicDate }}</div>
        <div class="sub-title-date1">当前</div>
        <div class="top-tab-style">
          <span
            :class="{ 'bottom-style': activeName == 'first' }"
            @click="changeTab('first')"
            >已决</span
          >
          <span
            :class="{ 'bottom-style': activeName == 'second' }"
            @click="changeTab('second')"
            >未决</span
          >
        </div>
      </div>

      <div
        class="card-item"
        v-if="activeName == 'first'"
        style="display: flex; justify-content: space-around"
      >
        <div class="card-detail">
          <div class="card-detail-title">
            <span class="icon-css">日</span>
            <span class="title-css">当日已决(万)</span>
          </div>
          <div class="card-detail-num">
            {{ totalCData.curDaySettled | formatDecimal }}
          </div>
          <div class="card-status-green aligncenter">
            <div
              class="status-bg marginright"
              v-if="totalCData.dayRateSettled >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="totalCData.dayRateSettled < 0 ? 'isUp' : 'isDown'"
            >
              {{ totalCData.dayRateSettled | formatPercent }}
            </div>
          </div>
        </div>
        <div class="card-detail" style="margin-left: 3%">
          <div class="card-detail-title">
            <span class="icon-css is-month">月</span>
            <span class="title-css">当月已决(万)</span>
          </div>
          <div class="card-detail-num">
            {{ totalCData.curMonSettled | formatDecimal }}
          </div>
          <div class="card-status-green aligncenter">
            <div
              class="status-bg marginright"
              v-if="totalCData.monRateSettled >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="totalCData.monRateSettled < 0 ? 'isUp' : 'isDown'"
            >
              {{ totalCData.monRateSettled | formatPercent }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="card-item"
        v-if="activeName == 'second'"
        style="display: flex; justify-content: space-around"
      >
        <div class="card-detail">
          <div class="card-detail-title">
            <span class="icon-css">日</span>
            <span class="title-css">当日未决(万)</span>
          </div>
          <div class="card-detail-num">
            {{ totalCData.curDayOutstand | formatDecimal }}
          </div>
          <div class="card-status-green aligncenter">
            <div
              class="status-bg marginright"
              v-if="totalCData.dayRateOutstand >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="totalCData.dayRateOutstand < 0 ? 'isUp' : 'isDown'"
            >
              {{ totalCData.dayRateOutstand | formatPercent }}
            </div>
          </div>
        </div>
        <div class="card-detail" style="margin-left: 3%">
          <div class="card-detail-title">
            <span class="icon-css is-month">月</span>
            <span class="title-css">当月未决(万)</span>
          </div>
          <div class="card-detail-num">
            {{ totalCData.curMonOutstand | formatDecimal }}
          </div>
          <div class="card-status-green aligncenter">
            <div
              class="status-bg marginright"
              v-if="totalCData.monRateOutstand >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="totalCData.monRateOutstand < 0 ? 'isUp' : 'isDown'"
            >
              {{ totalCData.monRateOutstand | formatPercent }}
            </div>
          </div>
        </div>
      </div>
      <div class="card-line"></div>
      <div
        class="card-item"
        style="margin-top: 0.1rem; display: flex; justify-content: space-around"
        v-if="activeName == 'first'"
      >
        <div class="card-detail" style="float: left">
          <div class="card-detail-title">
            <span class="icon-css is-quarter">季</span>
            <span class="title-css">本季已决(万)</span>
          </div>
          <div class="card-detail-num">
            {{ totalCData.curQutSettled | formatDecimal }}
          </div>
          <div class="card-status-green aligncenter">
            <div
              class="status-bg marginright"
              v-if="totalCData.qutRateSettled >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="totalCData.qutRateSettled < 0 ? 'isUp' : 'isDown'"
            >
              {{ totalCData.qutRateSettled | formatPercent }}
            </div>
          </div>
        </div>
        <div class="card-detail">
          <div class="card-detail-title">
            <span class="icon-css is-year">年</span>
            <span class="title-css">当年已决(万)</span>
          </div>
          <div class="card-detail-num">
            {{ totalCData.curYerSettled | formatDecimal }}
          </div>
          <div class="card-status-green aligncenter">
            <div
              class="status-bg marginright"
              v-if="totalCData.yerRateSettled >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="totalCData.yerRateSettled < 0 ? 'isUp' : 'isDown'"
            >
              {{ totalCData.yerRateSettled | formatPercent }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="card-item"
        style="margin-top: 0.1rem; display: flex; justify-content: space-around"
        v-if="activeName == 'second'"
      >
        <div class="card-detail" style="float: left">
          <div class="card-detail-title">
            <span class="icon-css is-quarter">季</span>
            <span class="title-css">本季未决(万)</span>
          </div>
          <div class="card-detail-num">
            {{ totalCData.curQutOutstand | formatDecimal }}
          </div>
          <div class="card-status-green aligncenter">
            <div
              class="status-bg marginright"
              v-if="totalCData.qutRateOutstand >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="totalCData.qutRateOutstand < 0 ? 'isUp' : 'isDown'"
            >
              {{ totalCData.qutRateOutstand | formatPercent }}
            </div>
          </div>
        </div>
        <div class="card-detail">
          <div class="card-detail-title">
            <span class="icon-css is-year">年</span>
            <span class="title-css">当年未决(万)</span>
          </div>
          <div class="card-detail-num">
            {{ totalCData.curYerOutstand | formatDecimal }}
          </div>
          <div class="card-status-green aligncenter">
            <div
              class="status-bg marginright"
              v-if="totalCData.yerRateSettled >= 0"
            >
              <img :src="toUp" class="upImg" alt="" />
            </div>
            <div class="status-bg-down marginright" v-else>
              <img :src="toDown" class="downImg" alt="" />
            </div>
            <div
              class="status-num"
              :class="totalCData.yerRateSettled < 0 ? 'isUp' : 'isDown'"
            >
              {{ totalCData.yerRateSettled | formatPercent }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" style="padding-bottom: 0.15rem">
      <div class="sub-title">
        <div class="sub-title-bar"></div>
        <div class="sub-title-text">分险种立案概况</div>
      </div>
      <div class="borderpolicy"></div>
      <table class="hoverTable">
        <tr>
          <th scope="templateName">险种</th>
          <th scope="amountMon">立案金额(月度)</th>
          <th scope="amountQut">立案金额(季度)</th>
          <th scope="amountYear">立案金额(年度)</th>
        </tr>
        <tr v-for="(item, index) in tableData" :key="index">
          <td>{{ item.templateName }}</td>
          <td>{{ item.amountMon | formatDecimal }}</td>
          <td>{{ item.amountQut | formatDecimal }}</td>
          <td>{{ item.amountYear | formatDecimal }}</td>
        </tr>
      </table>
    </div>
    <div class="line-chart">
      <lineChartTwo
        :respPreList1="respPreList"
        :respCurList1="respCurList"
        @func="getLineDataC"
      />
    </div>
    <div class="card">
      <div class="sub-title">
        <div class="sub-title-bar"></div>
        <div class="sub-title-text">分机构立案概况</div>
      </div>
      <div class="borderpolicy"></div>
      <div class="summaryTable">
        <table class="hoverTable" v-if="tableDataC.length>0">
          <tr>
            <th scope="comDesc">地区</th>
            <th scope="monAmount">立案金额(月度)</th>
            <th scope="qutAmount">立案金额(季度)</th>
            <th scope="yearAmount">立案金额(年度)</th>
          </tr>
          <tr v-for="(item, index1) in tableDataC" :key="index1">
            <td>{{ item.comDesc}}</td>
            <td>{{ item.monAmount | formatDecimal }}</td>
            <td>{{ item.qutAmount | formatDecimal }}</td>
            <td>{{ item.yearAmount | formatDecimal }}</td>
          </tr>
        </table>
        <div class="upOrDown">
          <van-icon
            name="arrow-down"
            class="el-icon-caret-bottom"
            v-if="isClose"
            @click="collSpan_c(1)"
          />
          <van-icon name="arrow-up" v-else @click="collSpan_c(2)"></van-icon>
        </div>
      </div>
    </div>

    <div class="pie-chart">
      <PieChartThree :tableDataPCopy1="tableDataCCopy" ref="pieChartThree" />
    </div>
    <div class="card">
      <div class="sub-title">
        <div class="sub-title-bar"></div>
        <div class="sub-title-text">赔案与支付情况</div>
      </div>
      <div class="borderpolicy" style="margin-bottom: 0.1rem"></div>
      <div
        class="card-item"
        style="display: flex; justify-content: space-around; height: 0.6rem"
      >
        <div class="card-detail" style="width: 50%">
          <div class="card-detail-title" style="height: 40%">
            <img class="cbnhcount" src="./../images/cbnhcount.png" alt="" />
            当年已决金额(含计数)
          </div>
          <div class="card-detail-num" style="font-size: 0.16rem">
            {{ paymentInfoObj.curYerSettled | formatDecimal }}&nbsp;&nbsp;万元
          </div>
        </div>
        <div class="card-detail" style="width: 50%">
          <div class="card-detail-title" style="height: 40%">
            <img class="cbnhcount" src="./../images/cbnhcount.png" alt="" />
            期初未决金额
          </div>
          <div class="card-detail-num" style="font-size: 0.16rem">
            {{ paymentInfoObj.preYerOutstand | formatDecimal }}&nbsp;&nbsp;万元
          </div>
        </div>
      </div>
      <div class="card-line"></div>
      <div
        class="card-item"
        style="
          margin-top: 0.1rem;
          display: flex;
          justify-content: space-around;
          height: 0.6rem;
        "
      >
        <div class="card-detail" style="float: right; width: 50%">
          <div class="card-detail-title" style="height: 40%">
            <img class="cbnhcount" src="./../images/cbnhcount.png" alt="" />
            期末未决金额
          </div>
          <div class="card-detail-num" style="font-size: 0.16rem">
            {{ paymentInfoObj.preDayOutstand | formatDecimal }}&nbsp;&nbsp;万元
          </div>
        </div>
        <div class="card-detail" style="width: 50%">
          <div class="card-detail-title" style="height: 40%">
            <img class="cbnhcount" src="./../images/cbnhcount.png" alt="" />
            当年赔款已支付合计
          </div>
          <div class="card-detail-num" style="font-size: 0.16rem">
            {{ paymentInfoObj.curYerPayment | formatDecimal }}&nbsp;&nbsp;万元
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toUp from "./../images/toUp.png";
import toDown from "./../images/todown.png";
import lineChartTwo from "../components/lineChartTwo.vue";
import PieChart from "../components/pieChart.vue";
import PieChartThree from "../components/pieChartThree.vue";
var obj = require("@/api/api.js");

// import api from "@/api/api.js";
export default {
  components: {
    lineChartTwo,
    PieChart,
    PieChartThree,
  },
  data() {
    return {
      basicDate: "",
      toUp,
      toDown,
      activeName: "first", // 已决/未决切换
      totalCData: {},
      respPreList: [],
      respCurList: [],
      contrastArray: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      tableData: [
        { type: "种植险" },
        { type: "养殖险" },
        { type: "林业险" },
        { type: "合计" },
      ], // 理赔概况表格
      claimOtherObj: {}, // 除江苏内蒙其他备份（年） --赔付概况
      claimTotalizeObj: {}, // 总计备份（年） --赔付概况
      claimArrayList: [], //赔付概况中下标2-14数据
      tableDataCCopy: [], //pie图使用
      isClose: true,
      tableDataC: [],
      paymentInfoObj: {},
      loginComCode: "",
    };
  },
  methods: {
    formatDate() {
      var time = new Date().getTime() - 24 * 60 * 60 * 1000;
      var yesterday = new Date(time);
      yesterday =
        yesterday.getFullYear() +
        "-" +
        (yesterday.getMonth() + 1  > 9
          ? yesterday.getMonth() + 1
          : "0" + (yesterday.getMonth() + 1)) +
        "-" +
        (yesterday.getDate() > 9
          ? yesterday.getDate()
          : "0" + yesterday.getDate());
      this.basicDate = yesterday;
    },
    // 切换已决/未决
    changeTab(TabIndex) {
      this.activeName = TabIndex;
    },
    // 赔付概况-理赔概况
    getTotalCData() {
      let queryClaimPay = obj.queryClaimPay;
      this.$http
        .post(queryClaimPay, { comcode: this.loginComCode })
        .then((res) => {
          this.totalCData = res.data;
          console.log(this.totalCData);
          this.$forceUpdate()
        });
    },
    // 赔付概况-分险种立案概况
    getLineDataC(params = {}) {
      let queryRiskPay = obj.queryRiskPay;
      //2022-01-19
      params.comcode = this.loginComCode;
      this.$http.post(queryRiskPay, params).then((res) => {
        var result = res.data;
        let preArrData = this.washDataMethods(result.respPreList);
        let curArrData = this.washDataMethods(result.respCurList);

        this.respPreList = []; // 清空数组
        this.respCurList = []; // 清空数组
        preArrData.map((item) => {
          let formatNum = parseFloat(Object.values(item)) / 10000;
          formatNum = formatNum.toFixed(2);
          this.respPreList.push(formatNum);
        });

        curArrData.map((item) => {
          let formatNum = parseFloat(Object.values(item)) / 10000;
          formatNum = formatNum.toFixed(2);
          this.respCurList.push(formatNum);
        });

        result.riskPayList.map((item) => {
          if (item.templateCode == "T01") {
            item.templateName = "种植险";
          } else if (item.templateCode == "T02") {
            item.templateName = "养植险";
          } else if (item.templateCode == "T03") {
            item.templateName = "森林险";
          } else {
            item.templateName = "合计";
          }
        });
        this.tableData = result.riskPayList;
        this.$forceUpdate()
      });
    },
    // 公共方法：数据缺少月份补0
    washDataMethods(targetArr) {
      let nowArr = [];
      targetArr.forEach((item) => {
        nowArr.push(Object.keys(item).toString());
      });

      for (var j = 0; j < this.contrastArray.length; j++) {
        let obj1 = {};
        if (nowArr.indexOf(this.contrastArray[j]) == -1) {
          obj1[this.contrastArray[j].toString()] = 0;
          targetArr.push(obj1);
        }
      }
      return targetArr;
    },
    //佩服概况-分机构立案概况
    getTableDataC() {
      let { queryComCodePay } = obj;
      this.$http
        .post(queryComCodePay, { comcode: this.loginComCode })
        .then((res) => {
          let result = res.data;
          if (result.rtnCode == "0000") {
            let comCodeArr = [];
            let respYLength = result.comCodePayList.length
            comCodeArr.push(result.comCodePayList[0]);
            comCodeArr.push(result.comCodePayList[1]);
            comCodeArr.push(result.comCodePayList[2]);
            comCodeArr.push(result.comCodePayList[respYLength-1]);
            let respYearArrP =[]
            respYearArrP.push(result.comCodePayList[0]);
            respYearArrP.push(result.comCodePayList[1]);
            let _newObjYear  =  JSON.parse(JSON.stringify(result.comCodePayList[2]) )
            console.log(_newObjYear)
            for (let i=3;i<respYLength-2;i++){
              _newObjYear.yearAmount+=result.comCodePayList[i].yearAmount
            }
            _newObjYear.comDesc = '其他'
            console.log(_newObjYear)
            respYearArrP.push(_newObjYear);
            respYearArrP.push(null);
            this.tableDataCCopy = respYearArrP
            this.claimOtherObj = result.comCodePayList[2];
            this.claimTotalizeObj = result.comCodePayList[respYLength-1];
            this.claimArrayList = result.comCodePayList.splice(2, 14);
            this.tableDataC = comCodeArr;
            // this.tableDataCCopy = JSON.parse(JSON.stringify(this.tableDataC));

            this.$forceUpdate()
          }
        });
    },
    collSpan_c(flag) {
      if (flag == 1) {
        this.tableDataC.splice(2, 2);
        this.claimArrayList.map((item) => {
          this.tableDataC.push(item);
        });
        this.tableDataC.push(this.claimTotalizeObj);
        this.isClose = false;
      } else {
        this.tableDataC.splice(2);
        this.tableDataC.push(this.claimOtherObj);
        this.tableDataC.push(this.claimTotalizeObj);
        this.isClose = true;
      }
      this.$forceUpdate()
    },
    queryPaymentInfo() {
      let { queryPaymentInfo } = obj;
      this.$http
        .post(queryPaymentInfo, { comcode: this.loginComCode })
        .then((res) => {
          var result = res.data;
          if (result.rtnCode == "0000") {
            this.paymentInfoObj = result;
          }
        });
    },
  },
  mounted() {
    this.loginComCode = this.$route.query.comcode;
    this.formatDate();
    this.getTotalCData();
    this.getLineDataC({ templateCode: "T01" });
    this.getTableDataC();
    this.queryPaymentInfo();
  },
  filters: {
    formatDecimal: function (value) {
      let decimal = value / 10000;
      return decimal.toFixed(2);
    },
    // 百分比转换
    formatPercent(value) {
      let Percent = value * 100;
      return Percent.toFixed(2) + "%";
    },
  },
};
</script>

<style scoped>
.policy-content {
  width: 100%;
  height: auto;
}

.sub-title {
  width: 100%;
  height: 0.24rem;
}

.sub-title-bar {
  width: 0.04rem;
  height: 0.16rem;
  background: #31d493;
  position: relative;
  top: 0.04rem;
  float: left;
}

.sub-title-text {
  font-size: 0.16rem;
  font-weight: bold;
  color: #333;
  line-height: 0.24rem;
  height: 0.24rem;
  margin-left: 0.06rem;
  float: left;
}

.sub-title-date {
  margin-left: 0.12rem;
  font-size: 0.14rem;
  color: #999;
  line-height: 0.24rem;
  height: 0.24rem;
  float: left;
}

.card {
  width: 100%;
  height: auto;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(83, 83, 83, 0.09);
  border-radius: 0.06rem;
  margin-top: 0.04rem;
  margin-bottom: 0.1rem;
  padding: 0.1rem;
  padding-bottom: 0.05rem;
}

.card-sub-title {
  color: #333;
  font-size: 0.14rem;
  line-height: 0.2rem;
  font-weight: bold;
  padding-bottom: 0.16rem;
}

.card-item {
  width: 100%;
  height: 0.9rem;
  /* display: flex; */
}

.card-detail {
  width: 31%;
  height: 100%;
  float: left;
}

.card-detail-title {
  font-size: 0.12rem;
  color: #666;
  line-height: 0.16rem;
}

.card-detail-num {
  font-weight: bold;
  color: #333;
  font-size: 0.2rem;
  margin-top: 0.05rem;
}

.card-status {
  color: #de5555;
  width: 100%;
  height: 0.2rem;
  margin-top: 0.05rem;
}
.card-status-green {
  color: #49dbb7;
  width: 100%;
  height: 0.2rem;
  margin-top: 0.05rem;
}

.status-num {
  float: left;
  font-size: 0.14rem;
  line-height: 0.2rem;
}

.up {
  color: #49dbb7;
}

.up-bg {
  /* background-image: url("../../../../../asset/images/up.png"); */
}

.status-bg {
  float: left;
  width: 0.12rem;
  height: 0.2rem;
  margin-left: 0.06rem;
  /* background: url("../../../../../asset/images/down.png") no-repeat center center;
  background-size: 0.12rem; */
}

.upImg,
.downImg {
  width: 0.12rem;
}

.status-bg-up {
  float: left;
  width: 0.12rem;
  height: 0.2rem;
  margin-left: 0.06rem;
  /* background: url("../../../../../asset/images/up.png") no-repeat center center;
  background-size: 0.12rem; */
}

.card-line {
  width: 100%;
  height: 0;
  border-bottom: 0.01rem #eee dashed;
}

.line-chart {
  width: 100%;
  height: 260px;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(83, 83, 83, 0.09);
  margin-bottom: 0.16rem;
  box-sizing: border-box;
}

.table-header {
  width: 100%;
  height: 0.44rem;
  background: #f6f8fe;
  padding: 0 0.2rem;
}

.header-text {
  width: 50%;
  height: 100%;
  float: left;
  color: #333;
  font-size: 0.14rem;
  line-height: 0.44rem;
}

.table-content {
  width: 100%;
  height: auto;
  background: #fff;
  border-radius: 0.06rem;
}

.table-content-item {
  width: 100%;
  height: 0.42rem;
  padding: 0 0.2rem;
}

.item-name {
  width: 50%;
  height: 100%;
  float: left;
  color: #333;
  font-size: 0.14rem;
  line-height: 0.44rem;
}

.item-detail {
  width: 50%;
  height: 100%;
  float: left;
}

.item-total {
  float: left;
  color: #333;
  font-size: 0.12rem;
  line-height: 0.44rem;
  font-weight: bold;
}

.item-percent {
  float: left;
  color: #49dbb7;
  font-size: 0.12rem;
  line-height: 0.44rem;
  margin-left: 0.05rem;
}

.item-bg {
  float: left;
  width: 0.12rem;
  height: 100%;
  margin-left: 0.05rem;
  position: relative;
}

.itemImg {
  width: 0.12rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.item-bg-down {
  float: left;
  width: 0.12rem;
  height: 100%;
  margin-left: 0.05rem;
  /* background: url("../../../../../asset/images/down.png") no-repeat center center;
    background-size: 0.12rem; */
}

.pie-chart {
  width: 100%;
  height: 2.9rem;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(83, 83, 83, 0.09);
  margin-top: 0.05rem;
  margin-bottom: 0.16rem;
}

.table-detail {
  width: 100%;
  height: auto;
  overflow: hidden;
  background: #fff;
}

.table-detail-text {
  width: 50%;
  float: left;
  height: auto;
  line-height: 0.24rem;
  color: #999;
}

.fr {
  float: right;
}

.mgl {
  margin-left: 3%;
}

.border-b {
  border-bottom: 1px dashed #535353;
}

table.hoverTable {
  border-collapse: collapse;
  padding: 15px;
}

table.hoverTable th {
  background-color: #f2f2f2;
  font-weight: bold;
  padding: 0.08rem;
  font-size: 0.14rem;
}
table.hoverTable tr {
  border-top: 1px solid #fbfbfb;
  background: #ffffff;
}
table.hoverTable td {
  font-size: 0.12rem;
  color: #7c8088;
  padding: 0.08rem;
}
.aligncenter {
  display: flex;
  align-items: center;
}
.marginright {
  margin-right: 0.05rem;
}
.borderpolicy {
  border: 0.01rem solid #eeeeee;
  opacity: 1;
  margin: 0.1rem -0.1rem;
}
.sub-title-date1 {
  font-size: 0.13rem;
  color: #fff;
  background: #31d493;
  padding: 0.03rem 0.06rem;
  border-radius: 0.03rem;
  margin-left: 0.05rem;
  float: left;
}
.top-tab-style {
  text-align: right;
  font-weight: bold;
  color: #999999;
  cursor: pointer;
  margin-bottom: 0.2rem;
  float: right;
}
.bottom-style {
  border-bottom: 3px solid #31d493;
  color: #333333;
}
.icon-css {
  font-size: 13px;
  color: #ffffff;
  background: #31d493;
  padding: 1px 5px;
  border-radius: 3px;
}
.title-css {
  color: #333333ff;
  font-weight: bold;
}
.is-month {
  background: #2a8cf1ff;
}
.is-quarter {
  background: #ffac63ff;
}
.is-year {
  background: #ff6363ff;
}
.isUp {
  color: #ff6363ff;
}
.isDown {
  color: #31d493;
}
.upOrDown {
  width: 100%;
  height: 20px;
  background: #eef1f6;
  text-align: center;
  cursor: pointer;
}
i {
  color: #31d493;
}
.cbnhcount {
  width: 0.18rem;
  height: 0.18rem;
  vertical-align: middle;
  margin-right: 0.05rem;
}
td {
  border: 1px solid rgba(238, 238, 238, 1);
}
</style>



// WEBPACK FOOTER //
// src/pages/operationSummary/components/claimSummary.vue